<button
  class="main-menu-button highlighted-dark git-stashed"
  mat-button
  *ngIf="state.stashedChanges?.length"
  [ngClass]="btnClass"
  [matTooltip]="'You have some stashed changes in progress that you have not yet committed.'"
  matTooltipClass="main-menu-tooltip"
  (click)="showStashedChanges()"
  data-test="button-git-open-stashed-changes"
>
  <fa-icon class="button-icon" [icon]="['fal', 'layer-group']"></fa-icon>
  <div>{{ state.stashedChanges.length }}x Stashed changes</div>
  <fa-icon [icon]="['fal', 'chevron-right']" *ngIf="showRightChevron" class="chevron-down devices-only"></fa-icon>
</button>
